export default {"src":"/_next/static/media/icon-SCID.fb48ac04.svg","height":10,"width":12,"blurWidth":0,"blurHeight":0};